module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm White Ceramic + White Closed.b933fa12.png";